import { MetaAdReferral } from 'data/firestore/globals';

export interface AdPreview {
    adId?: string;
    body?: string;
    imageUrl?: string;
    linkUrl?: string;
    title?: string;
}

type ReferralFields = {
    adId?: string;
    adsContext?: {
        adTitle?: string;
        photoUrl?: string;
    };
    body?: string;
    headline?: string;
    imageUrl?: string;
    refererUri?: string;
    sourceId?: string;
    sourceType?: string;
    sourceUrl?: string;
    thumbnailUrl?: string;
};

const getAdPreview = (referral: MetaAdReferral): AdPreview => {
    const fields = referral as ReferralFields;
    const sourceId = fields.sourceType === 'ad' || !fields.sourceType
        ? fields.sourceId
        : undefined;

    return {
        adId: sourceId || fields.adId,
        body: fields.body,
        imageUrl: fields.imageUrl || fields.thumbnailUrl || fields.adsContext?.photoUrl,
        linkUrl: fields.sourceUrl || fields.refererUri,
        title: fields.headline || fields.adsContext?.adTitle,
    };
};

export default getAdPreview;
